import React, { useEffect, useState } from "react";
import "./home.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardAction } from "../redux/actions/UserActions";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
// import moment from "moment";

const Home = () => {
  // const dashboardData = useSelector(state => state.user.dashboardData);
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const loading = useSelector((state) => state.loading.value);
  // const lastActivities = useSelector(state => state.user?.dashboardData?.lastActivities)
  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalImages, setTotalImages] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [carouselImages, setCarouselImages] = useState(0);
  const [totalLinks, setTotalLinks] = useState(0);

  const fetchDashboardData = async () => {
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    setLoading(true);
    try {
      const res = await axios.get(`${BaseUrl}/api/dashboard/counts`, {
        headers: { "Content-Type": "application/json", Authorization: token },
      });

      if (res.data.status == 200) {
        setTotalImages(res.data.data.galleryCounts.reduce((acc, item) => acc + item.count, 0));
        setTotalNotifications(res.data.data.notificationCounts.reduce((acc, item) => acc + item.count, 0));
        setCarouselImages(res.data.data.galleryCounts[1].count || 0);
        setTotalLinks(res.data.data.linkCounts.reduce((acc, item) => acc + item.count, 0));
      } else {
        toast.error("Failed to fetch data.");
      }

      const resactivity = await axios.get(`${BaseUrl}/api/dashboard/recentActivity`, {
        headers: { "Content-Type": "application/json", Authorization: token },
      });

      if (resactivity.data.status == 200) {

        setRecentActivity(resactivity.data.data || []);
      } else {
        toast.error("Failed to fetch data.");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);


  // useEffect(() => {
  //   console.log("fetching dashboard")
  //   const token= sessionStorage.getItem("userToken")
  //   if(!token){
  //     navigate("/login")
  //   }
  // }, []);
  // useEffect(() => {
  //   if ("") {
  //     setRecentActivity()
  //   }
  // }, []);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <h3>Dashboard</h3>
          <div className="dashboard-stats">
            <div className="stat-card">
              <h3>Total Images</h3>
              <p>{totalImages}</p>
            </div>
            <div className="stat-card">
              <h3>Total Notifications</h3>
              <p>{totalNotifications}</p>
            </div>
            <div className="stat-card">
              <h3>Carousel Images</h3>
              <p>{carouselImages}</p>
            </div>
            <div className="stat-card">
              <h3>Total Links</h3>
              <p>{totalLinks}</p>
            </div>
          </div>

          <div className="recent-activity">
            <h2>Recent Activity</h2>
            <hr />
            {recentActivity ? (
              <div className="timeline-container">
                {recentActivity?.map((item, index) => (
                  <>
                    <div className="timeline-date-group" key={index}>
                      <div className="timeline-indicator">
                        <div className="timeline-dot"></div>
                        <div className="timeline-line"></div>
                      </div>

                      <div className="timeline-content">
                        <div className="timeline-date">
                          <h5>{new Date(item.lastActivity).toISOString().split("T")[0]}</h5>
                        </div>
                        <div className="timeline-tasks">
                          <div className="timeline-card">
                            <p className="timeline-card-action">
                              <strong>{item.source}</strong> {item.activityType}{" "}
                              by <strong>Admin</strong> in{" "}
                              {item.activityDetails}.
                            </p>
                            <div className="timeline-card-footer float-right">
                              <span className="timeline-card-date">
                                {new Date(item.lastActivity).toISOString().slice(0, 16).replace("T", " ")}
                              </span>
                              <span
                                className={`timeline-card-assignee ${item.activityType === "Created"
                                  ? "new"
                                  : item.activityType === "Deleted"
                                    ? "deleted"
                                    : item.activityType === "Updated"
                                      ? "update"
                                      : ""
                                  }`}
                              >
                                {item.activityType}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            ) : (
              <p>No recent activity</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
